import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import React from 'react';
import { Controller } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
import { MyMDropDownList } from '../ui-elements/MyMDropDownList';

/**
 * 入力チェック用ドロップダウンリスト Component
 */
// 2024.5.8 MyMine Version1.5対応 Modify Start
const ValidatableDropDownList = ({ control, name, options, defaultValue, needsBlank, rules, formState, onChange, disabled, maxWidth, placeholder, ...other }) => {
  // 2024.5.8 MyMine Version1.5対応 Modify End
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ''}
      render={({ field: { ref, ...field } }) =>
        <FormControl error={formState.errors[name] ? true : false} sx={maxWidth && { width: '100%' }}>
          {/* 2024.5.8 MyMine Version1.5対応 Add Start */}
          {placeholder && <InputLabel sx={{ marginTop: '-5px', color: 'rgba(0, 0, 0, 0.6) !important' }}>{placeholder}</InputLabel>}
          {/* 2024.5.8 MyMine Version1.5対応 Add End */}
          <MyMDropDownList
            {...field}
            options={options}
            needsBlank={needsBlank}
            sx={maxWidth && { width: '100%' }}
            onChange={((e) => {
              field.onChange(e);
              onChange && onChange(e);
            })}
            disabled={disabled}
            // 2024.5.8 MyMine Version1.5対応 Add Start
            {...other}
          // 2024.5.8 MyMine Version1.5対応 Add End
          />
          <FormHelperText>{!disabled && formState.errors[name]?.message}</FormHelperText>
        </FormControl>
      }
      rules={rules}
    />
  );
};
export default ValidatableDropDownList;
